import { render, staticRenderFns } from "./EmailResetInviata.vue?vue&type=template&id=51cf8601&scoped=true&"
import script from "./EmailResetInviata.vue?vue&type=script&lang=js&"
export * from "./EmailResetInviata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51cf8601",
  null
  
)

export default component.exports